import React from 'react'
import translation from '../../../../translations/template.json'
import { useLocaleStore } from '../../../Contexts/localeStore'
import { ArrowIcon } from '../../../Icons/ArrowIcons'
import { imageFiles } from '../../../../utils/imageFiles'

interface VocalReminderProps {
  className?: string
  handleClose: () => void
}

const VocalReminder = ({
  className,
  handleClose
}: VocalReminderProps): JSX.Element => {
  const { locale } = useLocaleStore((state) => ({
    locale: state.locale
  }))

  return (
    <div
      className={`hover:rf-cursor-pointer rf-flex rf-flex-row rf-items-start ${className}`}
      onClick={handleClose}
    >
      <img src={imageFiles.leaMini} className='rf-h-12' />
      <div className='rf-flex rf-flex-col rf-align-start rf-justify-start'>
        <div className='rf-flex rf-flex-col rf-pl-2'>
          {(translation[locale]?.reminder || translation['fr-FR']?.reminder)
            .split('\n')
            .map((line, key) => {
              return <div key={key}>{line}</div>
            })}
        </div>
        <ArrowIcon />
      </div>
    </div>
  )
}

export default VocalReminder
